import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const LOADED_ICONS = new Map();
let IconComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.svg = null;
    this.attributes = {};
    this.isMounted = false;
    this.displayAltText = false;
  }
  loadSvg() {
    return __async(this, null, function* () {
      if (!this.name || !this.path) {
        return;
      }
      this.clearElement();
      this.isMounted = false;
      const assetPath = this.magicConfig.paths ? this.magicConfig.paths.assets.svg : this.path;
      const path = `${assetPath}/${this.name}.svg`;
      if (!LOADED_ICONS.has(path)) {
        LOADED_ICONS.set(path, fetch(path).then((resp) => {
          const contentType = resp.headers.get("Content-Type");
          if (!contentType || !contentType.includes("image/svg+xml")) {
            console.warn(`Could not load SVG as '${contentType}' content type is incorrect: ${path}`);
            return "Error";
          }
          return resp.text();
        }));
      }
      const svgText = yield LOADED_ICONS.get(path);
      const fragment = document.createElement("template");
      fragment.innerHTML = svgText;
      const svg = fragment.content.querySelector("svg");
      if (!svg) {
        console.warn(`SVG '${path}' did not contain an SVG element`);
        return this.altTextFallback();
      }
      this.svg = svg;
      this.mountSvgContent();
      const attributes = {};
      for (const attribute of Array.from(svg.attributes)) {
        this.$set(attributes, attribute.nodeName, attribute.nodeValue);
      }
      this.attributes = attributes;
    });
  }
  onAttributesChange() {
    for (const attribute of Object.keys(this.$attrs)) {
      this.$set(this.attributes, attribute, this.$filteredAttrs[attribute]);
    }
  }
  clearElement() {
    if (!this.$refs.svg) {
      return;
    }
    const svgRef = this.$refs.svg;
    while (svgRef.firstChild) {
      svgRef.removeChild(svgRef.firstChild);
    }
  }
  mounted() {
    this.mountSvgContent();
  }
  mountSvgContent() {
    if (!this.svg || !this.$refs.svg || this.isMounted) {
      return;
    }
    const svg = this.svg;
    const nodes = svg.children;
    const svgRef = this.$refs.svg;
    this.clearElement();
    for (const node of Array.from(nodes)) {
      svgRef.appendChild(node);
    }
    this.isMounted = true;
  }
  altTextFallback() {
    this.displayAltText = this.altText ? true : false;
  }
};
__decorateClass([
  Prop(String)
], IconComponent.prototype, "name", 2);
__decorateClass([
  Prop({ type: String, default: "/img/icons" })
], IconComponent.prototype, "path", 2);
__decorateClass([
  Prop({ type: String, default: "div" })
], IconComponent.prototype, "tag", 2);
__decorateClass([
  Prop(Boolean)
], IconComponent.prototype, "badge", 2);
__decorateClass([
  Prop(String)
], IconComponent.prototype, "altText", 2);
__decorateClass([
  Watch("path", { immediate: true }),
  Watch("name", { immediate: true })
], IconComponent.prototype, "loadSvg", 1);
__decorateClass([
  Watch("$attrs", { deep: true })
], IconComponent.prototype, "onAttributesChange", 1);
IconComponent = __decorateClass([
  Component({
    inheritAttrs: false,
    name: "ui-icon"
  })
], IconComponent);

export default IconComponent;
